export default {
  search: {
    title: "Buscar",
    trending: "Tendencias",
    noResults: 'No se encontraron resultados para "{{query}}"',
    sections: {
      games: "Partidos",
      props: "Props",
      position: "Posición",
      trending: "Tendencias",
      players: "Jugadores",
      teams: "Equipos",
      markets: "Mercados",
      matchups: "Enfrentamientos",
    },
    empty: {
      noResults: 'No se encontraron resultados para "{{query}}"',
      noGamesAvailable: "No hay partidos disponibles",
      checkBackLater: "Vuelve más tarde",
    },
    actions: {
      searchByGame: "Buscar por partido",
      viewMatchups: "Ver enfrentamientos",
      searchByProp: "Buscar por prop",
      searchByPosition: "Buscar por posición",
    },
    discovery: {
      Hits: "Hits",
      "Total Bases": "Bases totales",
      RBI: "Carreras impulsadas",
      Strikeouts: "Ponches",
      Results: "Resultados",
      Totals: "Totales",
      "Goals & Assists": "Goles y asistencias",
      "Shots on Goal": "Tiros a puerta",
      Points: "Puntos",
      "Powerplay Points": "Puntos en power play",
    },
    positions: {
      Forwards: "Delanteros",
      Midfielders: "Mediocampistas",
      Defense: "Defensa",
      Guards: "Bases y escoltas",
      Centers: "Pívots",
      QB: "QB",
      RB: "RB",
      WR: "WR",
      TE: "TE",
      K: "K",
      Wingers: "Extremos",
      Goalies: "Porteros",
      Pitchers: "Lanzadores",
      Hitters: "Bateadores",
    },
  },
};